import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"
import { HttpError, isError } from "../../../helpers/Error"
import { ExportInventoryDtoAttributes } from "../models"

export class Service {
    static async post(postData : ExportInventoryDtoAttributes): Promise<ExportInventoryDtoAttributes[] | HttpError> { 
        const res = await AppContext.getApiClient().post("/inventory-export", postData)
        if (isError(res) || res.error) {
            return res as HttpError
        }
        return res as ExportInventoryDtoAttributes[]
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/exports/service/service.ts